

<div class="row" cdkDropListGroup>
  <div class="col-12 position-relative">
    <div class="save-button-container">
      <button class="btn btn-sm btn-primary" (click)="saveParcels()">{{ 'SAVE_PARCELS' | translate }}</button>
    </div>
  </div>

  <!-- PRODUCTS LIST -->
  <div
    class="col-12 col-lg-6 mb-3"
    cdkDropList
    #productList="cdkDropList"
    id="productList"
    [cdkDropListData]="productMappedData"
    [cdkDropListConnectedTo]="connectedDropListsIds"
    (cdkDropListDropped)="drop($event)"
  >
    <div class="parcel-management-dragdrop-list-container">
      <div class="parcel-management-dragdrop-list-header">
        <h4>{{ 'PRODUCTS' | translate }}</h4>
        <button class="btn btn-sm btn-primary" (click)="selectAll()">{{ 'SELECT_ALL' | translate }}</button>
      </div>

      @for (item of productMappedData; track item.tempId) {
        <div class="parcel-management-dragdrop-list-item" cdkDrag>
          <div><input type="checkbox" [(ngModel)]="item.selected" /></div>

          <div class="list-item-image">
            <img
              class="img-fluid"
              *ngIf="productIdMap?.[item.ids?.gungId]?.extra?.images?.length > 0"
              [src]="productIdMap[item.ids.gungId].extra.images[0].s3Uri
                | gungImageUrl
                  :'type:thumbnail'
                  :'etag:' + productIdMap[item.ids.gungId].extra.images[0].s3ETag"
              alt=""
            />
          </div>

          <div class="list-item-id">
            <span>{{ 'ID' | translate }}: {{ item.ids?.gungId }}</span>
            @if (item.ids?.ean13) {
              <br />
              <span>{{ 'EAN' | translate }}: {{ item.ids?.ean13 }}</span>
            }
          </div>

          <div class="list-item-name">{{ item.name }}</div>

          <div class="list-item-quantity ml-auto"><input class="form-control" type="number" [value]="item.quantity" disabled></div>

          <div class="action-buttons">
            <button class="btn btn-sm btn-outline-primary" (click)="openSplitProductModal(item)"><i class="fa-regular fa-split"></i></button>
          </div>
        </div>
      }
    </div>
  </div>

  <!-- PARCELS LIST -->
  <div class="col-12 col-lg-6">
    <div class="parcel-container">
      <div class="parcel-header">
        <h4>{{ 'PARCELS' | translate }}</h4>
        <button class="btn btn-sm btn-primary" (click)="openAddEditParcelModal()">{{ 'ADD_PARCEL' | translate }}</button>
      </div>

      <div class="parcel-content">
        @for (parcel of parcelMappedData; let i = $index; track parcel.ginIdentifier) {
          <div class="parcel-container mb-3">
            <div class="parcel-header">
              <span>{{ parcel.id ? (parcel.id + ' -') : '' }} {{ parcel.ginIdentifier }}</span>
              <div class="action-buttons">
                <button class="btn btn-sm btn-outline-primary" (click)="dropSelectedProducts(i)"><i class="fa-regular fa-arrow-down-to-square"></i></button>
                <button class="btn btn-sm btn-outline-primary" (click)="openAddEditParcelModal(i, parcel)"><i class="far fa-edit"></i></button>
                <button class="btn btn-sm btn-outline-primary" (click)="removeParcel(i)"><i class="fa-regular fa-trash"></i></button>
              </div>
            </div>

            <div class="parcel-content-list">
              <div
                class="parcel-management-dragdrop-list-container no-top-radius no-border"
                cdkDropList
                #parcelDropListRefs="cdkDropList"
                [id]="'parcelList' + i"
                [cdkDropListData]="parcel.items"
                [cdkDropListConnectedTo]="connectedDropListsIds"
                (cdkDropListDropped)="drop($event)"
              >
                @for (item of parcel.items; track item.tempId) {
                  <div class="parcel-management-dragdrop-list-item" cdkDrag>
                    <div><input type="checkbox" [(ngModel)]="item.selected" /></div>

                    <div class="list-item-image">
                      <img
                        class="img-fluid"
                        *ngIf="productIdMap?.[item.ids?.gungId]?.extra?.images?.length > 0"
                        [src]="productIdMap[item.ids.gungId].extra.images[0].s3Uri
                          | gungImageUrl
                            :'type:thumbnail'
                            :'etag:' + productIdMap[item.ids.gungId].extra.images[0].s3ETag"
                        alt=""
                      />
                    </div>

                    <div class="list-item-id">
                      <span>{{ 'ID' | translate }}: {{ item.ids?.gungId }}</span>
                      @if (item.ids?.ean13) {
                        <br />
                        <span>{{ 'EAN' | translate }}: {{ item.ids?.ean13 }}</span>
                      }
                    </div>

                    <div class="list-item-name">{{ item.name }}</div>

                    <div class="list-item-quantity ml-auto"><input class="form-control" type="number" [value]="item.quantity" disabled></div>

                    <div class="action-buttons">
                      <button class="btn btn-sm btn-outline-primary" (click)="openEditParcelProductDetails(i, item)"><i class="far fa-edit"></i></button>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
